// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BPofY","buttons":"styles_buttons__32sEI"};